// 协议签署弹窗：后端对关键操作返回 403 TERMS_NOT_ACCEPTED 时，api 拦截器经 utils/terms 广播 TERMS_REQUIRED_EVENT，
// 本组件（挂在 App 根）弹出《用户协议》《隐私政策》全文，勾选后「同意」→ POST /legal/accept 留痕。
// 同意后提示用户重新提交（不自动重放原请求：原请求可能带文件/已部分改动表单，重放易出意外）。
import React, { useEffect, useState } from 'react';
import { Modal, Tabs, Checkbox, Typography, message } from 'antd';
import api from '../services/api';
import { TERMS_REQUIRED_EVENT } from '../utils/terms';
import { apiError } from '../utils/apiError';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

export const LegalText = ({ text }) => {
  const { t } = useTranslation('common');
  return <Paragraph style={{ whiteSpace: 'pre-wrap', maxHeight: 360, overflowY: 'auto' }}>{text || t('legal.empty')}</Paragraph>;
};

const TermsModal = () => {
  const [legal, setLegal] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    const onRequired = async () => {
      try {
        const res = await api.get('/legal');
        if (res.data?.version) {
          setAgreed(false);
          setLegal(res.data);
        }
      } catch (e) {
        message.error(t('legal.loadFailed'));
      }
    };
    window.addEventListener(TERMS_REQUIRED_EVENT, onRequired);
    return () => window.removeEventListener(TERMS_REQUIRED_EVENT, onRequired);
  }, []);

  const accept = async () => {
    setSaving(true);
    try {
      await api.post('/legal/accept', { version: legal.version });
      message.success(t('legal.accepted'));
      setLegal(null);
    } catch (error) {
      message.error(apiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={t('legal.modalTitle')}
      open={!!legal}
      onCancel={() => setLegal(null)}
      onOk={accept}
      okText={t('legal.agree')}
      cancelText={t('legal.later')}
      okButtonProps={{ disabled: !agreed }}
      confirmLoading={saving}
      width={680}
    >
      {legal && (
        <>
          <Tabs
            items={[
              { key: 'terms', label: t('legal.terms'), children: <LegalText text={legal.terms} /> },
              { key: 'privacy', label: t('legal.privacy'), children: <LegalText text={legal.privacy} /> },
            ]}
          />
          <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
            {t('legal.checkbox', { version: legal.version })}
          </Checkbox>
        </>
      )}
    </Modal>
  );
};

export default TermsModal;
